import { useState, useEffect } from "react";
import { captchaPublicKey } from "env"
import * as CaptchaLib from "@repoflow/browser/captcha";

export const useCaptcha = function () {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!global.grecaptcha) {
      CaptchaLib.init(captchaPublicKey, () => {
        setReady(true);
      });
    } else {
      setReady(true);
    }
  }, []);

  return { publicKey: captchaPublicKey, ready };
};
